// Guida contestuale del software.
// HELP: testi mostrati dal pulsante "?" in base alla pagina (chiave = path della rotta).
// Modifica liberamente i testi qui: non serve toccare il codice dei componenti.

export const HELP = {
  "/": {
    title: "Dashboard",
    audience: "Tutti",
    points: [
      "È la schermata iniziale: mostra il riepilogo della giornata (ospiti presenti, turni, pulizie, menù).",
      "Seleziona la struttura in alto per vedere i dati di quella casa. 'Tutte' mostra il totale.",
      "I riquadri con la freccia 'Apri →' portano alla sezione dedicata.",
    ],
  },
  "/consegne": {
    title: "Consegne",
    audience: "OSS",
    points: [
      "Scrivi qui le note di consegna tra un turno e l'altro (cosa è successo, cosa segnalare).",
      "Firma sempre con il tuo PIN così resta traccia di chi ha scritto.",
      "Leggi le consegne del turno precedente prima di iniziare.",
    ],
  },
  "/terapie": {
    title: "Terapie",
    audience: "OSS / Infermieri",
    points: [
      "Vedi automaticamente tutti gli ospiti attivi della struttura scelta: i nuovi ospiti compaiono da soli.",
      "Le terapie NON sono divise per mese: restano attive finché non vengono sospese o eliminate.",
      "Per aggiungere, sospendere o eliminare una terapia usa il pulsante 'Storico' dell'ospite.",
      "Quando sei loggato col PIN, la tua firma viene presa in automatico sulle modifiche.",
    ],
  },
  "/controllo-terapie": {
    title: "Controllo terapie",
    audience: "OSS",
    points: [
      "Serve a controllare che ogni ospite abbia preso la terapia del giorno.",
      "Segnala SOLO chi NON l'ha presa (e quali medicine): gli altri restano a posto.",
      "Usa le frecce ◀ ▶ o 'Oggi' per cambiare giorno; il giorno visualizzato è nel badge in alto.",
    ],
  },
  "/non-mangia": {
    title: "Non mangia",
    audience: "OSS",
    points: [
      "Controlla che ogni ospite mangi. Segnala solo chi NON ha mangiato.",
      "Indica i pasti saltati e, se serve, una nota.",
      "Il giorno visualizzato è nel badge in alto; cambia giorno con le frecce.",
    ],
  },
  "/non-beve": {
    title: "Non beve",
    audience: "OSS",
    points: [
      "Controlla l'idratazione. Segnala solo chi NON ha bevuto a sufficienza.",
      "Aggiungi una nota se noti qualcosa di importante.",
      "Il giorno visualizzato è nel badge in alto; cambia giorno con le frecce.",
    ],
  },
  "/alzate": {
    title: "Alzate",
    audience: "OSS",
    points: [
      "Registra le alzate degli ospiti nel giorno visualizzato (badge in alto).",
      "Usa il pulsante rapido per confermare l'alzata di un ospite.",
      "Consulta lo storico dei giorni precedenti con le frecce.",
    ],
  },
  "/messa-a-letto": {
    title: "Messa a letto",
    audience: "OSS",
    points: [
      "Registra la messa a letto degli ospiti nel giorno visualizzato (badge in alto).",
      "Cambia giorno con le frecce ◀ ▶ o torna a 'Oggi'.",
    ],
  },
  "/alvo": {
    title: "Alvo intestinale",
    audience: "OSS",
    points: [
      "Registra l'evacuazione degli ospiti giorno per giorno.",
      "Serve a tenere sotto controllo la regolarità e segnalare eventuali problemi.",
    ],
  },
  "/docce": {
    title: "Docce",
    audience: "OSS",
    points: [
      "Segna le docce/igiene effettuate nel giorno.",
      "Aiuta a rispettare la rotazione settimanale dell'igiene.",
    ],
  },
  "/parametri": {
    title: "Parametri",
    audience: "OSS / Infermieri",
    points: [
      "Registra i parametri vitali (pressione, saturazione, ecc.).",
      "I valori fuori norma vengono evidenziati per una verifica rapida.",
    ],
  },
  "/cadute": {
    title: "Cadute",
    audience: "OSS",
    points: [
      "Registra ogni caduta con data, ora e descrizione.",
      "È importante per la sicurezza e per eventuali comunicazioni alla famiglia/medico.",
    ],
  },
  "/presenze": {
    title: "Presenze operatori",
    audience: "OSS",
    points: [
      "Qui si registra la presenza degli operatori in servizio.",
      "Firma con il tuo PIN per validare la presenza.",
    ],
  },
  "/pulizie": {
    title: "Pulizie",
    audience: "OSS",
    points: [
      "Mostra le pulizie da fare oggi divise per area/stanza.",
      "Spunta le attività man mano che le completi.",
    ],
  },
  // ---- AREA AMMINISTRAZIONE ----
  "/rette": {
    title: "Ricavi e rette",
    audience: "Amministrazione",
    points: [
      "Ogni ospite ha una 'retta prevista'. Ogni mese generi le rette e segni gli incassi.",
      "Usa 'Solo non pagate' + 'Segna come pagati' per spuntare più rette insieme.",
      "Gli incassi confluiscono nella Dashboard di gestione.",
    ],
  },
  "/spese": {
    title: "Spese",
    audience: "Amministrazione",
    points: [
      "Un unico foglio per Vitto, Affitto, Utenze e Varie, mese per mese.",
      "Le spese con IVA/ritenuta finiscono nel box F24; l'F24 del mese è solo INPS+IRPEF.",
      "Usa 'Duplica mese' o le 'Ricorrenti fisse' per non riscrivere le spese fisse ogni mese.",
    ],
  },
  "/buste_paga": {
    title: "Buste paga",
    audience: "Amministrazione",
    points: [
      "Inserisci i costi del personale mese per mese (netto, INPS, IRPEF, INAIL, TFR).",
      "F24 da pagare subito = solo INPS + IRPEF. L'INAIL entra nell'F24 di maturazione (dopo il TFR).",
      "I costi confluiscono nella Dashboard di gestione e nel modulo TFR/F24.",
    ],
  },
  "/controllo": {
    title: "Dashboard di gestione",
    audience: "Amministrazione",
    points: [
      "Riepiloga ricavi, spese e costo del personale per struttura e per mese.",
      "Clicca un mese (o le frecce/tendina nel dettaglio) per vedere il dettaglio economico.",
      "Il 'Risultato gestionale' = incassi − spese totali − personale.",
    ],
  },
  "/extra": {
    title: "Extra",
    audience: "Amministrazione",
    points: [
      "Registro libero di entrate e uscite non collegate alle altre categorie.",
      "Seleziona mese e anno; il risultato del mese è calcolato in automatico.",
    ],
  },
};

// Contenuto della pagina "Come funziona" (area Amministrazione).
export const FLUSSI = [
  {
    id: "rette",
    title: "Ricavi e rette",
    color: "#1f7a5c",
    steps: [
      "Inserisci l'ospite (categoria Ospiti) con la sua retta prevista.",
      "Nella pagina Ricavi e rette scegli il mese e premi 'Genera ospiti del mese'.",
      "Segni gli incassi (singoli o in blocco con 'Segna come pagati').",
      "Gli importi confluiscono automaticamente nella Dashboard di gestione.",
    ],
    nota: "Un ospite dimesso resta nei mesi passati ma sparisce dai mesi futuri (storico preservato).",
  },
  {
    id: "spese",
    title: "Spese e F24 fornitori",
    color: "#c2410c",
    steps: [
      "Registri le spese nel foglio Spese (Vitto, Affitto, Utenze, Varie) per mese.",
      "Le spese con IVA/ritenuta d'acconto alimentano il box F24 fornitori.",
      "Usa 'Duplica mese' o 'Ricorrenti fisse' per le spese ricorrenti.",
      "Le spese confluiscono nella Dashboard di gestione.",
    ],
    nota: "Il totale per categoria e l'IVA/ritenuta sono sempre visibili nel riepilogo in alto.",
  },
  {
    id: "personale",
    title: "Buste paga → TFR/F24",
    color: "#2f6fb0",
    steps: [
      "Inserisci i costi del personale nelle Buste paga (netto, INPS, IRPEF, INAIL, TFR).",
      "F24 del mese (giorno 16) = solo INPS + IRPEF.",
      "L'INAIL viene accantonato e versato nell'F24 di maturazione, dopo il pagamento del TFR.",
      "Tutto confluisce nella Dashboard di gestione e nel modulo TFR e F24.",
    ],
    nota: "Nel riepilogo Buste paga: 'F24 da pagare subito' = INPS+IRPEF; 'F24 costi che maturano' = INAIL.",
  },
  {
    id: "dashboard",
    title: "Dashboard di gestione",
    color: "#7c3aed",
    steps: [
      "Raccoglie automaticamente ricavi, spese e personale di ogni struttura.",
      "Per ogni mese calcola il Risultato = incassi − spese totali − costo del personale.",
      "Nel dettaglio mese puoi navigare con frecce e tendina.",
      "La categoria Previsioni permette di confrontare con il budget/business plan.",
    ],
    nota: "Seleziona una struttura specifica in alto per analizzare una singola casa.",
  },
];

export const FAQ = [
  {
    q: "Ho inserito un nuovo ospite ma non lo vedo nelle rette del mese.",
    a: "Vai in Ricavi e rette, scegli il mese e premi 'Genera ospiti del mese': verrà aggiunto con la sua retta prevista.",
  },
  {
    q: "Perché l'F24 da pagare subito non include l'INAIL?",
    a: "L'F24 mensile (giorno 16) è solo INPS + IRPEF. L'INAIL fa parte dei costi che maturano e si versa con l'F24 di maturazione, dopo il TFR.",
  },
  {
    q: "Un fornitore va assegnato a una struttura?",
    a: "No. I fornitori sono a livello azienda e valgono per tutte le strutture: non viene chiesta la struttura.",
  },
  {
    q: "Come faccio a vedere i dati di una sola casa?",
    a: "Usa i pulsanti (o la tendina su mobile) in alto a sinistra per selezionare la struttura. 'Tutte' mostra il totale complessivo.",
  },
  {
    q: "Un operatore ha finito il contratto: lo elimino?",
    a: "No, usa la 'Cessazione': resta nei mesi passati (storico) ma sparisce dai mesi futuri.",
  },
];
